import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
type StatusRowProps = {
  label: string;
  status: string;
  variant: 'positive' | 'negative' | 'neutral';
};
const StatusRow = t0 => {
  const $ = _c(10);
  const {
    label,
    status,
    variant
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <p className="text-body-2 text-tertiary">{label}</p>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== variant) {
    t2 = cx("text-body-2", {
      "text-success": variant === "positive"
    }, {
      "text-error": variant === "negative"
    }, {
      "text-tertiary": variant === "neutral"
    });
    $[2] = variant;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== status || $[5] !== t2) {
    t3 = <p className={t2}>{status}</p>;
    $[4] = status;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <div className="flex items-center justify-between">{t1}{t3}</div>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default StatusRow;